import React from 'react';
import { MovingBoxCalculator } from './MovingBoxCalculator';
import '../../styles/moving-calculator.scss';

export const MovingCalculatorContainer = () => {

  return (
    <MovingBoxCalculator />
  );
};